var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectService({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18C24 18.75 23.79 19.46 23.42 20.06C23.21 20.42 22.94 20.74 22.63 21C21.93 21.63 21.01 22 20 22C18.78 22 17.69 21.45 16.97 20.59C16.95 20.56 16.92 20.54 16.9 20.51C16.78 20.37 16.67 20.22 16.58 20.06C16.21 19.46 16 18.75 16 18C16 16.74 16.58 15.61 17.5 14.88C18.19 14.33 19.06 14 20 14C21 14 21.9 14.36 22.6 14.97C22.72 15.06 22.83 15.17 22.93 15.28C23.59 16 24 16.95 24 18Z",
    stroke: "#003087",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4898 17.98H18.5098",
    stroke: "#003087",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.52V19.51",
    stroke: "#003087",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16992 7.44L12.9999 12.55L21.7699 7.46997",
    stroke: "#003087",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 21.61V12.54",
    stroke: "#003087",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6106 9.17V14.83C22.6106 14.88 22.6106 14.92 22.6006 14.97C21.9006 14.36 21.0006 14 20.0006 14C19.0606 14 18.1906 14.33 17.5006 14.88C16.5806 15.61 16.0006 16.74 16.0006 18C16.0006 18.75 16.2106 19.46 16.5806 20.06C16.6706 20.22 16.7806 20.37 16.9006 20.51L15.0706 21.52C13.9306 22.16 12.0706 22.16 10.9306 21.52L5.59062 18.56C4.38062 17.89 3.39062 16.21 3.39062 14.83V9.17C3.39062 7.79 4.38062 6.11002 5.59062 5.44002L10.9306 2.48C12.0706 1.84 13.9306 1.84 15.0706 2.48L20.4106 5.44002C21.6206 6.11002 22.6106 7.79 22.6106 9.17Z",
    stroke: "#003087",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectService);
export default __webpack_public_path__ + "static/media/select-service.47692347.svg";
export { ForwardRef as ReactComponent };